import { useQuery } from '@tanstack/react-query';

import { fetchNotifications, type NotificationFilters } from '../api/notifications.api';

export const NOTIFICATIONS_KEY = 'notifications';

export function useNotificationsList(filters: NotificationFilters = {}) {
  return useQuery({
    queryKey: [NOTIFICATIONS_KEY, filters],
    queryFn: () => fetchNotifications(filters),
    staleTime: 0,
  });
}
